<template>
  <div>
    <div class="background" style="position: relative;" ref="card">
      <div v-for="(area, areaIndex) in cityList">
        <div class="bg-white area"  v-if="area.citys.length > 0">
          <div class="input-item" style="display: flex">
            <div class="line"></div>
            <span class="text-nowrap">{{ area.name }}</span>
          </div>
          <ul class="city-list">
            <li v-for="(city, i) in area.citys" :key="i" @click.prevent="checkedThisCity(city)">
              <div class="city">
                <div>{{ city.name }}</div>
                <div class="arrow">
                  <span class="tenOff" v-show="city.id === 'taipei'">95折優惠</span>
                  <span class="tenOff" v-show="city.id === 'kaohsiung'">最高5折優惠</span>
                  <span class="tenOff" v-show="city.id === 'newTaipeiCity'">機車折5元</span>
                  <span class="tenOff" v-show="city.id === 'taichung'">智慧開單8折</span>
                  <span class="tenOff" v-show="city.id === 'taoyuan' ">95折優惠</span>
                  <img src="@/assets/images/iconArrowSign.png" width="24pt"></div>
              </div>
            </li>          
          </ul>
        </div>
      </div>
    </div>
    <div class="padding description">
      <ul class="text-gray2">        
        <li>可使用悠遊付錢包、銀行帳戶連結、信用卡進行繳費 扣款。惟臺北市使用信用卡扣款<span class="text-blue">限台新銀行、玉山銀 行發卡之信用卡</span>，其他縣市無信用卡發卡銀行限制。</li>
        <li>已逾期限之帳單是否提供繳費，請依各縣市停管處網站公告為準。</li>
        <li class="text-blue">臺北市路邊臨時停車費95折優惠持續中。</li>       
        <li v-if="!is2025()">高雄市路邊停車費舊用戶於繳費期限內（即停車次日起14日內）繳納停車費享95折優惠， 新用戶於113年7月1日起至12月31日止享6折優惠，新用戶係指113年7月1日以前未曾使用過行動支付繳納高雄市路邊停車費之車號。</li> 
        <li v-if="is2025()">高雄市路邊停車費於繳費期限內，舊用戶使用行動支付APP繳費享95折優惠，新用戶加碼於114年4月1日至114年6月30日期間繳費可參加抽獎外，還可更享有停車費5折優惠。「新用戶」指114年4月1日前未曾使用過行動支付APP繳納高雄市路邊停車費之車號。</li> 
        <li>新北市路邊停車費於113年8月1日起至114年12月31日止使用行動支付繳納新北市機車路邊停車繳費單每筆折扣5元。</li>
        <li>臺中市路邊停車費智慧開單8折係指使用行動支付繳納臺中市地磁停車單(藍單)，享停車費8折優惠。</li>
        <li>桃園市路邊停車費於114年6月1日起至114年12月31日止使用行動支付繳納桃園市路邊停車繳費享95折。</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'roadside-parking-step2',
  props: {    
  },
  data() {
    return {
      // city_list: [{name: '基隆市'}, {name: '台北市'}, {name: '新北市'}, {name: '桃園市'}, {name: '新竹縣'}, {name: '新竹市'}, {name: '台中市'}, {name: '台南市'}, {name: '高雄市'}],
      cityList: [
        {
          name: '北部',
          citys: [
            { name: '臺北市', id: 'taipei' },
            { name: '新北市', id: 'newTaipeiCity' },         
            { name: '基隆市', id: 'keelung' },         
            { name: '桃園市', id: 'taoyuan' },         
            { name: '新竹市', id: 'hsinchuCity' }, 
            { name: '新竹縣', id: 'hsinchu' }, 
            { name: '宜蘭縣', id: 'yilan' },
          ]
        },
        {
          name: '中部',
          citys: [
            { name: '臺中市', id: 'taichung' },
            { name: '南投縣', id: 'nantou' },
          ]
        },
        {
          name: '南部',
          citys: [
            { name: '臺南市', id: 'tainan' }, 
            { name: '高雄市', id: 'kaohsiung' },
          ]
        },
        {
          name: '東部',
          citys: [
            
          ]
        },
        {
          name: '離島',
          citys: [

          ]
        }
       
        
        
      ],
      isDisabled: false,
      checked: '',
    };
  },
  created() {
    this.cityList.forEach((el) => {
      this.$set(el, 'class', 'radio-group');
    });
    //this.cityList[0].class = 'radio-group active';
    //this.checkPreSelectCity();
  },
  methods: {
    is2025() {
      return new Date().getFullYear() >= 2025;
    },
    checkPreSelectCity() {
      if (this.$route.query.city_id !== undefined && this.$route.query.city_id !== '') {
        var found = false;
        for (let i = 0; i < this.cityList.length; i++) {
          for (let j = 0; j < this.cityList[i].citys.length; j++) {
            if (this.cityList[i].citys[j].id === this.$route.query.city_id) {
              this.checked = this.$route.query.city_id;
              this.checkedThisCity(this.cityList[i].citys[j]);
              found = true;
              break;
            }
          }
          if (found) {
            break;
          }
        }
      }
    },
    checkedThisCity(city) {
      console.log('city=' + JSON.stringify(city));
      this.checked = city.id;
      this.setParent();
    },
    setParent() {
      var city;
      this.cityList.forEach((area) => {
        area.citys.forEach((el) => {        
          if (el.id === this.checked) {
            city = el;
          }
        });
      });
      this.$emit('citySelected', city.id, city.name);
    },
  },
};
</script>

<style scoped>
.area {
  padding: 24pt 16pt 0 16pt;
}

.background {
  background-color: #f9f9f9;
}

.city {
  padding-top: 16pt;
  padding-bottom: 16pt;
  border-bottom: 1px solid  #19404040;
  display: flex;
}

ul.city-list li {
  list-style-type: none;
}

ul.city-list li div  {
  font-family: PingFangTC-Regular;
}

ul.city-list li:last-child div {
    border-bottom: none;
}

ul.city-list {
  font-size: 12pt;
  font-style: normal;
  padding-inline-start: 0px;
  margin-bottom: 20px;
}

.tenOff {
  background: #e7007f;
  color: #fff;
  border-radius: 12pt;
  padding: 2pt 6pt;
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  font-family: PingFangTC-Regular;
}
.arrow {
  margin-left: auto;
  justify-content: center;
  display: flex; /* Establishes flex context */
  flex-direction: row; 
}

.arrow img {
  width: 24px;
  height: 24px;
}
</style>
